import { Dispatch } from "redux";
import { getAccountStatement, getBlockedIbanService, getAccounts, getRequisite, getCardStatement } from '../../../services/account';
import { AccountStatementAction, AccountStatementActionTypes } from "../../types/accountsStatement";
import { Notify } from 'components/Notification';

export const getSalaryAccountStatement = (payload: any) => {
  const { company, formData, paginationData, otp } = payload;
  
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({ type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_REQUEST });

    if (formData.ibanRef) {
      // Birbaşa API-dan gələn promise-i return edirik
      return getAccountStatement(company, { ...formData, otp }, paginationData)
        .then(response => {
          dispatch({
            payload: {
              result: response,
            },
            type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_SUCCESS,
          });
          
          return response; // Komponentdəki 'data' dəyişəninin mənimsəməsi üçün məlumatı qaytarırıq
        })
        .catch((error: any) => {
          dispatch({
            error: {
              result: error.response,
            },
            type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_ERROR,
          });
          
          throw error; // Komponentdəki try/catch blokunun (catch hissəsinin) işə düşməsi üçün xətanı fırladırıq
        });
    } else {
      dispatch({
        payload: {
          result: [],
        },
        type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_SUCCESS,
      });
      
      return Promise.resolve([]); // ibanRef boş olduqda zəncirin qırılmaması üçün resolve olunmuş boş array qaytarırıq
    }
  };
};

export const getAccountStatementData = (payload: any) => {
  const { company, formData, otp } = payload;

  return (dispatch: Dispatch<AccountStatementAction>) => {
    // resolve və reject parametrlərini əlavə edirik
    return new Promise((resolve, reject) => {
      dispatch({ type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_REQUEST });
console.log(formData)
      if (formData.ibanRef) {
        getCardStatement(company, { ...formData, otp })
          .then(response => {
            dispatch({
              payload: { result: response.IB4C_Statement_by_Card_IBAN_Resp },
              type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_SUCCESS,
            });
            resolve(response); // Uğurlu olduqda Promise-i bitir
          })
          .catch((error: any) => {
            dispatch({
              error: { result: error.response },
              type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_ERROR,
            });
            // ƏSAS HİSSƏ: Kənardakı try-catch-ə xətanı göndəririk
            reject(error.response || error); 
          });
      } else {
        dispatch({
          payload: { result: [] },
          type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_SUCCESS,
        });
        resolve([]); // Məlumat yoxdursa da bitir
      }
    });
  };
};

export const setFilterData = (value:object) => {
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({
      type: AccountStatementActionTypes.SET_ACCOUNTS_STATEMENT_FILTER,
      payload: value
    })
  }
}

export const setCCYName = (value:object) => {
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({
      type: AccountStatementActionTypes.SET_CCY_NAME,
      payload: value
    })
  }
}



export const getBlockedIbanData = (payload: any) => {

  const { company, ibanRef } = payload;

  return (dispatch: Dispatch<AccountStatementAction>) => {
    return new Promise(() => {
      dispatch({ type: AccountStatementActionTypes.GET_BLOCKED_IBAN_REQUEST })

      if (ibanRef) {
        getBlockedIbanService(company, ibanRef)
          .then(response => {
            dispatch({
              payload: {
                result: response,
              },
              type: AccountStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS,
            })
          })
          .catch((error: any) => {
            dispatch({
              error: {
                result: error.response,
              },
              type: AccountStatementActionTypes.GET_BLOCKED_IBAN_ERROR,
            })
          })
      } else{
        dispatch({
          payload: {
            result: [],
          },
          type: AccountStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS,
        })
      }

    })
  }
}


export const getAccountsData = (payload: any) => {

  const { company } = payload;

  return (dispatch: Dispatch<AccountStatementAction>) => {
    return new Promise(() => {
      dispatch({ type: AccountStatementActionTypes.GET_ACCOUNTS_DATA_REQUEST })
      getAccounts(company)
          .then(response => {
            dispatch({
              payload: {
                result: response,
              },
              type: AccountStatementActionTypes.GET_ACCOUNTS_DATA_SUCCESS,
            })
          })
          .catch((error: any) => {
            dispatch({
              error: {
                result: error.response,
              },
              type: AccountStatementActionTypes.GET_ACCOUNTS_DATA_ERROR,
            })
          })

    })
  }
}


export const setMoreDetail = (value:object) => {
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({
      type: AccountStatementActionTypes.SET_MORE_DETAIL,
      payload: value
    })
  }
}


export const setIbanNumber = (value:object) => {
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({
      type: AccountStatementActionTypes.SET_IBAN_NUMBER,
      payload: value
    })
  }
}


export const getRequisiteData = (payload: any) => {
 // console.log("isledi getRequisiteData")
  const { company, ibanRef } = payload;
  // console.log(ibanRef)
  return (dispatch: Dispatch<AccountStatementAction>) => {
    return new Promise(() => {


      dispatch({ type: AccountStatementActionTypes.GET_REQUISITE_REQUEST })

      if (ibanRef) {

        getRequisite(company, ibanRef)
          .then(response => {
            dispatch({
              payload: {
                result: response,
              },
              type: AccountStatementActionTypes.GET_REQUISITE_SUCCESS,
            })
          })
          .catch((error: any) => {
            dispatch({
              error: {
                result: error.response,
              },
              type: AccountStatementActionTypes.GET_REQUISITE_ERROR,
            })
          })
      } else{

        dispatch({
          payload: {
            result: [],
          },
          type: AccountStatementActionTypes.GET_REQUISITE_SUCCESS,
        })
      }

    })
  }
}


export const setAccountLoading = (value:boolean) => {
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({
      type: AccountStatementActionTypes.SET_ACCOUNT_LOADING,
      payload: value
    })
  }
}

export const setBalanceLoading = (value:boolean) => {
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({
      type: AccountStatementActionTypes.SET_BALANCE_LOADING,
      payload: value
    })
  }
}

export const setTransferWidgetLoading = (value:boolean) => {
  return (dispatch: Dispatch<AccountStatementAction>) => {
    dispatch({
      type: AccountStatementActionTypes.SET_TRANSFER_WIDGET_LOADING,
      payload: value
    })
  }
}